import {  getBotConfigList } from "@/services/bot";
import { SET_BOT_CONFIG_LIST } from "./constants";

export const getBotConfigListAction = (user_id) => {
   return (dispatch) => {
      getBotConfigList(user_id).then((res) => {
         if(res.code===0&&res.data.length>0){
            dispatch(setBotConfigListAction(res.data[0]));
         }else{
            dispatch(setBotConfigListAction(null));
         }
      });
   };
};
export const setBotConfigListAction = (res) => ({
   type: SET_BOT_CONFIG_LIST,
   res,
});
